import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AboutGallery from "../components/AboutGallery";
import { api } from "../lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function SobreMi() {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    api.get("/about").then(({ data }) => setAbout(data)).catch(() => setAbout({ title: "Sobre mí", text: "" }));
  }, []);

  return (
    <div data-testid="sobremi-page" className="min-h-screen">
      <Navbar />
      <section className="pt-32 pb-20 max-w-6xl mx-auto px-6">
        <p className="overline mb-3">Etérea Enlace</p>
        <h1 data-testid="sobremi-title" className="font-display text-5xl sm:text-6xl text-white font-light tracking-tighter mb-14">
          {about?.title || "Sobre mí"}
        </h1>
        {about && (
          <div className={`grid gap-12 items-start ${about.image_url ? "md:grid-cols-[2fr_3fr]" : ""}`}>
            {about.image_url && (
              <div className="relative">
                <div className="absolute -inset-3 border border-[#C9A25E]/25 pointer-events-none" />
                <img data-testid="sobremi-image" src={`${BACKEND_URL}${about.image_url}`} alt={about.title}
                  className="relative w-full aspect-[4/5] object-cover" />
              </div>
            )}
            <div data-testid="sobremi-text" className="text-zinc-300 leading-relaxed text-base sm:text-lg whitespace-pre-wrap">
              {about.text || "Muy pronto compartiré aquí mi historia."}
            </div>
          </div>
        )}
        {about && <AboutGallery items={about.gallery} />}
      </section>
      <Footer />
    </div>
  );
}
